import { useEffect, useState } from 'react';
import { IconButton } from '@pocketlaw/tetris';
export function ToolbarButton(props) {
    const { commandKey, tooltip, editor, children } = props;
    const [active, setActive] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const handleClick = () => {
        editor === null || editor === void 0 ? void 0 : editor.execute(commandKey);
    };
    useEffect(() => {
        const command = editor.commands.get(commandKey);
        const handleCommandValueChange = (event, propertyName, newValue) => {
            setActive(newValue);
        };
        const handleCommandEnabledChange = (event, propertyName, newValue) => {
            setDisabled(!newValue);
        };
        command === null || command === void 0 ? void 0 : command.on('change:value', handleCommandValueChange);
        command === null || command === void 0 ? void 0 : command.on('change:isEnabled', handleCommandEnabledChange);
        return () => {
            command === null || command === void 0 ? void 0 : command.off('change:value', handleCommandValueChange);
            command === null || command === void 0 ? void 0 : command.off('change:isEnabled', handleCommandEnabledChange);
        };
    }, [editor, commandKey]);
    return (<IconButton type="button" size="small" appearance={active ? 'primary' : 'ghost'} disabled={disabled} aria-label={tooltip} onClick={handleClick}>
      {children}
    </IconButton>);
}
